import type {
  FiWordCloudPresetPayload,
  FiWordCloudSettingsCore,
} from "@mapmycustomers/shared/types/entity/fieldInsight";

import type { WordCloudConfig } from "@app/component/executiveSummary/types";
import { DEFAULT_WORD_CLOUD_CONFIG } from "@app/component/executiveSummary/util/consts";

// Always send whitelist and excludedWords as arrays for symmetric request shape.
export const toBeSettings = (
  config: WordCloudConfig
): Omit<FiWordCloudPresetPayload, "roleKey"> => ({
  excludedWords: config.excludedWords,
  maxWords: config.maxWords ?? null,
  whitelist: config.whitelist,
});

export const fromBeSettings = (settings: FiWordCloudSettingsCore | undefined): WordCloudConfig => {
  if (!settings) {
    return DEFAULT_WORD_CLOUD_CONFIG;
  }
  return {
    excludedWords: settings.excludedWords ?? [],
    maxWords: settings.maxWords ?? DEFAULT_WORD_CLOUD_CONFIG.maxWords,
    whitelist: settings.whitelist ?? [],
  };
};
